/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useEffect } from "react";


import { useIsAuthenticated } from "@azure/msal-react";
import { SignOutButton } from "./SignOutButton";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();

    useEffect(() => {

        const handleLogin = (loginType) => {
            if (!isAuthenticated) {
                if (loginType === "popup") {
                    instance.loginPopup(loginRequest).catch(e => {
                       // console.log(e);
                    });
                } else if (loginType === "redirect") {
                    instance.loginRedirect(loginRequest).catch(e => {
                        //console.log(e);
                    });
                }
            }
        }

        handleLogin("redirect");
    }, []);

    return (
        <>
            <div >
                { isAuthenticated ? <SignOutButton /> : <div/> }
            </div>            
            {/* <br />
            <br /> */}
            {props.children}
        </>
    );
};
